import config from "@root/amplify_outputs.json";
import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/data";
import { type Schema } from "@root/amplify/data/resource";


Amplify.configure(config, { ssr: true });

export const AmplifyServerConfig = Amplify.getConfig;

export const amplifyClient = generateClient<Schema>();